import React from 'react'
interface NameCellProps {
  name: React.ReactNode
  meta: React.ReactNode
}

const NameCell = ({ name, meta }: NameCellProps) => {
  return (
    <div>
      <strong>{name}</strong> <br />
      {meta}
    </div>
  )
}

export default NameCell
